<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  firstName: { type: String, default: '' },
  newProcesses: { type: Number, default: 0 },
});

const emit = defineEmits(['dismiss']);
const { t } = useI18n();
</script>

<template>
  <section
    class="h-[102px] w-full max-w-full rounded-[10px] border border-[#D5DEE2] bg-white px-6 py-4 font-[Roboto] text-sm text-[#5D696F] shadow-lais-card"
  >
    <div class="flex h-full items-center justify-between">
      <div
        class="pointer-events-none flex items-center gap-12 max-md:w-[278px] max-md:shrink-0"
      >
        <img
          src="~dashboard/assets/images/nucleo-welcome.png"
          :alt="t('REAL_ESTATE_COMMISSION_SUPPORT.NOTICE_IMAGE_ALT')"
          class="h-[70px] w-[63px] shrink-0 object-contain"
        />
        <div class="max-md:w-[167px] max-md:shrink-0">
          <p class="mb-[7px] text-[20px] font-bold leading-6 text-lais-text">
            {{
              t('REAL_ESTATE_COMMISSION_SUPPORT.WELCOME', { name: firstName })
            }}
          </p>
          <span class="text-base font-normal leading-[normal] text-[#74848B]">
            {{ t('REAL_ESTATE_COMMISSION_SUPPORT.NEW_PROCESSES_PREFIX') }}
            <strong class="font-bold text-lais-text">{{ newProcesses }}</strong>
            {{ t('REAL_ESTATE_COMMISSION_SUPPORT.NEW_PROCESSES_SUFFIX') }}
          </span>
        </div>
      </div>
      <button
        type="button"
        class="grid size-5 shrink-0 place-items-center !rounded-none text-lais-text-muted transition hover:text-lais-text"
        :aria-label="t('REAL_ESTATE_COMMISSION_SUPPORT.ACTIONS.DISMISS_NOTICE')"
        @click="emit('dismiss')"
      >
        <span class="i-lucide-x size-4" aria-hidden="true" />
      </button>
    </div>
  </section>
</template>
